import { render, staticRenderFns } from "./GroupLeftSideBar.vue?vue&type=template&id=6ca2383e&"
import script from "./GroupLeftSideBar.vue?vue&type=script&lang=js&"
export * from "./GroupLeftSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports